import React from "react";
import {Link} from "react-router-dom";
import {CButton, CCol, CFormGroup, CRow, CForm} from "@coreui/react";
import "./RecoveryPassword.scss";
import {withErrorBoundary} from "../../components/ErrorBoundary";
import {useTranslation} from "react-i18next";
import {PATHS} from "../../route-dictionary";

const RecoveryPassword = ({children, onFormSubmit, infoText}) => {
  const {t} = useTranslation();

  return (
    <CForm className="RecoveryPassword" onSubmit={onFormSubmit}>
      <p className="RecoveryPassword__info-text">{infoText}</p>
      {children}
      <CFormGroup>
        <CButton
          className="RecoveryPassword__submit-button"
          type="submit"
          color="primary"
        >
          {t("button.send", "Send")}
        </CButton>
      </CFormGroup>
      <CRow>
        <CCol xs={12} className="card-column-buttons">
          <CButton
            color="link"
            tag={Link}
            to={PATHS.LOGIN.ROOT}
            className="card-column-buttons__button"
          >{
            t("button.login", "Sign In")}
          </CButton>
          <CButton
            color="link"
            tag={Link}
            to={PATHS.SIGN_UP.ROOT}
            className="card-column-buttons__button"
          >
            {t("button.registerNewAccount", "Create a new account")}
          </CButton>
        </CCol>
      </CRow>
    </CForm>
  );
};

export default withErrorBoundary(RecoveryPassword);